
/** --------------------------------------------------------------------------------------------------
 * 開啟'儲存中'視窗
 * -------------------------------------------------------------------------------------------------- */

window.showLoadingDialog = function() {

    // ------------------------ 儲存中視窗 -------------------
    if ($('#rd-loading-dialog').length === 0) {
        $('body').append('<div class="load-wrapp" id="rd-loading-dialog">' +
                         '    <div class="square-holder">' +
                         '        <div class="square"></div>' +
                         '    </div>' +
                         '</div>');
    }

    $("#rd-loading-dialog").show();

} // end of method

window.hideLoadingDialog = function() {
    $("#rd-loading-dialog").hide();
} // end of method
